export const typeOfVehicle = [
    {
        name: "2 Wheeler",
        value: "2-Wheeler",
        disabled: false
    },
    {
        name: "3 Wheeler",
        value: "3-Wheeler",
        disabled: false
    },
    {
        name: "4 Wheeler",
        value: "4-Wheeler",
        disabled: true
    },
    {
        name: "Bus",
        value: "Bus",
        disabled: true
    },
    {
        name: "Truck",
        value: "Truck",
        disabled: true
    }
]

export const fuelType = [
    {
        name: "Battery Operated",
        value: "Electric",
        disabled: false
    },
    {
        name: "Conventional",
        value: "Conventional",
        disabled: true
    },
    {
        name: "Hybrid",
        value: "Hybrid",
        disabled: true
    }
]

export const TypeofCertification = [
    {
        name: "New-Type Approval Certification",
        value: "New-Type Approval Certification",
        disabled: false
    },
    {
        name: "Extension- Type Approval Certification",
        value: "Extension- Type Approval Certification",
        disabled: true
    },
    {
        name: "Retrofitment",
        value: "Retrofitment",
        disabled: true
    }
]

export const VehicleMaxspeed = [
    {
        name: "Less than  25 kmph",
        value: "Less than  25 kmph",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than  70 kmph",
        value: "Less than  70 kmph",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Greater than  70 kmph",
        value: "Greater than  70 kmph",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than  25 kmph",
        value: "Less than  25 kmph",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    },
    {
        name: "Greater than  25 kmph",
        value: "Greater than  25 kmph",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    }
]

export const NominalPowerofMotor = [
    {
        name: "Less than  250Watt",
        value: "Less than  250Watt",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than  4Kwatt",
        value: "Less than  4Kwatt",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Greater than 4KWatt",
        value: "Greater than 4KWatt",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than  2Kwatt",
        value: "Less than  2Kwatt",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    },
    {
        name: "Greater than 2KWatt",
        value: "Greater than 2KWatt",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    }
]

export const PeakPowerofMotor = [
    {
        name: "Less than  250Watt",
        value: "Less than  250Watt",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than  4Kwatt",
        value: "Less than  4Kwatt",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Greater than 4KWatt",
        value: "Greater than 4KWatt",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than  2Kwatt",
        value: "Less than  2Kwatt",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    },
    {
        name: "Greater than 2KWatt",
        value: "Greater than 2KWatt",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    }
]

export const Length = [
    {
        name: "Less than 4m",
        value: "Less than 4m",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than 2.8m",
        value: "Less than 2.8m",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    },
    {
        name: "Less than 4m",
        value: "Less than 4m",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    }

]

export const Width = [
    {
        name: "Less than 1m",
        value: "Less than 1m",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than 2m",
        value: "Less than 2m",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than 1m",
        value: "Less than 1m",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    },
    {
        name: "Less than 1.6m",
        value: "Less than 1.6m",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    }


]

export const Height = [
    {
        name: "Less than 2.5m",
        value: "Less than 2.5m",
        disabled: false,
        typeOfVehicle: '2-Wheeler'
    },
    {
        name: "Less than 1.8m",
        value: "Less than 1.8m",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    },
    {
        name: "Less than 2.5m",
        value: "Less than 2.5m",
        disabled: false,
        typeOfVehicle: '3-Wheeler'
    }
]



export const Category = [
    {
        name: "CMVR Exemption-LowSpeed",
        value: "CMVR Exemption-LowSpeed",
        disabled: false
    },
    {
        name: "L1 Category",
        value: "L1 Category",
        disabled: false
    },
    {
        name: "L2 Category",
        value: "L2 Category",
        disabled: false
    },
    {
        name: "E Rickshaw",
        value: "E Rickshaw",
        disabled: false
    },
    {
        name: "E Cart",
        value: "E Cart",
        disabled: false
    },
    {
        name: "L5M",
        value: "L5M",
        disabled: false
    },
    {
        name: "L5N",
        value: "L5N",
        disabled: false
    }

]

export const PrefferedTestingAgency = [
    {
        name: "ARAI",
        value: "ARAI",
        disabled: false
    },
    {
        name: "ICAT",
        value: "ICAT",
        disabled: false
    },
    {
        name: "GARC",
        value: "GARC",
        disabled: false
    },
    {
        name: "CIRT",
        value: "CIRT",
        disabled: false
    }
]
export const CmvrExemption =
    {
        speedValue: "Less than  25 kmph",
        nominalPower: "Less than  250Watt",
        peekPower: "Less than  250Watt",
        typeOfVehicle: '2-Wheeler',
        categoryName: 'CMVR Exemption-LowSpeed'
    } as const;

export const L1Category =
    {
        speedValue: "Less than  70 kmph",
        nominalPower: "Less than  4Kwatt",
        peekPower: "Less than  4Kwatt",
        width: 'Less than 1m',
        length: 'Less than 4m',
        height: 'Less than 2.5m',
        typeOfVehicle: '2-Wheeler',
        categoryName: 'L1 Category'
    } as const;

export const L2Category =
    {
        speedValue: "Greater than  70 kmph",
        nominalPower: "Greater than 4KWatt",
        peekPower: "Greater than 4KWatt",
        width: 'Less than 2m',
        length: 'Less than 4m',
        height: 'Less than 2.5m',
        typeOfVehicle: '2-Wheeler',
        categoryName: 'L2 Category'
    } as const;

export const ERickshaw =
    {
        speedValue: "Less than  25 kmph",
        nominalPower: "Less than  2Kwatt",
        peekPower: "Less than  2Kwatt",
        width: 'Less than 1m',
        length: 'Less than 2.8m',
        height: 'Less than 1.8m',
        typeOfVehicle: '3-Wheeler',
        categoryName: 'E Rickshaw',
        orCategoryName: 'E Cart'
    } as const;

export const L5ML5N =
    {
        speedValue: "Greater than  25 kmph",
        nominalPower: "Greater than 2KWatt",
        peekPower: "Greater than 2KWatt",
        width: 'Less than 1.6m',
        length: 'Less than 4m',
        height: 'Less than 2.5m',
        typeOfVehicle: '3-Wheeler',
        categoryName: 'L5N',
        orCategoryName: 'L5M'
    } as const;

export const checkDownLoad = false;